
import useNewItemChange from '../../EHR Settings/Templates/OpenTemplate/FormBuilder/hooks/useNewItemChange';

const Notes = ({ item, setItem, activeAccordion }) => {
  const { handleSetAnswer } = useNewItemChange(setItem, 'Viewer', activeAccordion);

  return (
    <div className='px-2 '>
      <p className='text font-m ar-light-color fs-13 pb-3px'>{item.content}</p>
      <div className="input w-25">
        <textarea
          className="form-control"
          rows={3}
          value={item.answer}
          onChange={(e) => handleSetAnswer(e, item)}
        />
      </div>
    </div>
  );
};

export default Notes